<template>
    <div v-if="typeof validationError !== 'undefined'" class="invalid-feedback">
        <span v-for="(value,key,index) in validationError">{{ value }}</span>
    </div>
    <div v-else class="valid-feedback">
<!--        Looks good!-->
    </div>
</template>

<script>
    export default {
        name: "LaraError",
        props: {
            validationError: undefined
        }
    }
</script>

<style scoped>

</style>
